import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit", "code", "submit", "waiting", "ready", "timer"]
  static values = { resendIn: { type: Number, default: 0 } }

  connect() {
    this.syncCode()
    this.startResendTimer()
    if (this.hasDigitTarget) this.digitTargets[0]?.focus()
  }

  disconnect() {
    this.stopResendTimer()
  }

  submitted(event) {
    if (!event.detail.success) return

    window.location.assign("/")
  }

  input(event) {
    const input = event.target
    const value = input.value.replace(/\D/g, "").slice(-1)
    input.value = value

    if (value && this.indexOf(input) < this.digitTargets.length - 1) {
      this.digitTargets[this.indexOf(input) + 1].focus()
    }

    this.syncCode()
  }

  keydown(event) {
    const input = event.target
    const index = this.indexOf(input)

    if (event.key === "Backspace" && !input.value && index > 0) {
      event.preventDefault()
      this.digitTargets[index - 1].focus()
      this.digitTargets[index - 1].value = ""
      this.syncCode()
    }
  }

  paste(event) {
    event.preventDefault()
    const text = (event.clipboardData || window.clipboardData).getData("text") || ""
    const digits = text.replace(/\D/g, "").slice(0, this.digitTargets.length).split("")

    this.digitTargets.forEach((input, index) => {
      input.value = digits[index] || ""
    })

    const focusIndex = Math.min(digits.length, this.digitTargets.length - 1)
    this.digitTargets[focusIndex]?.focus()
    this.syncCode()
  }

  syncCode() {
    const code = this.digitTargets.map((input) => input.value).join("")
    if (this.hasCodeTarget) this.codeTarget.value = code

    const complete = code.length === this.digitTargets.length
    if (this.hasSubmitTarget) this.submitTarget.disabled = !complete

    if (complete) this.submitForm()
  }

  submitForm() {
    if (this.submitting) return
    this.submitting = true

    const form = this.codeTarget?.form || this.submitTarget?.form
    if (!form) return

    this.digitTargets.forEach((input) => { input.readOnly = true })
    form.requestSubmit(this.hasSubmitTarget ? this.submitTarget : undefined)
  }

  startResendTimer() {
    this.stopResendTimer()
    this.updateResendUI()

    if (this.resendInValue <= 0) return

    this.timerId = window.setInterval(() => {
      this.resendInValue = Math.max(0, this.resendInValue - 1)
      this.updateResendUI()
      if (this.resendInValue <= 0) this.stopResendTimer()
    }, 1000)
  }

  stopResendTimer() {
    if (this.timerId) {
      window.clearInterval(this.timerId)
      this.timerId = null
    }
  }

  updateResendUI() {
    const seconds = this.resendInValue
    const waiting = seconds > 0

    if (this.hasWaitingTarget) this.waitingTarget.classList.toggle("d-none", !waiting)
    if (this.hasReadyTarget) this.readyTarget.classList.toggle("d-none", waiting)

    if (waiting && this.hasTimerTarget) {
      const minutes = String(Math.floor(seconds / 60)).padStart(2, "0")
      const rest = String(seconds % 60).padStart(2, "0")
      this.timerTarget.textContent = `${minutes}:${rest}`
    }
  }

  indexOf(input) {
    return this.digitTargets.indexOf(input)
  }
}
